import React from 'react';
import { Button } from '@mui/material';
import ShareIcon from '@mui/icons-material/Share';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { useTranslation } from 'react-i18next';
import { Message } from '@src/types/messages';

interface Props {
	data: Message;
}

const ChatMessageLocation: React.FC<Props> = ({ data }) => {
	const { t } = useTranslation();

	const location = data.waba_payload?.location;
	const coordinates = `${location?.latitude},${location?.longitude}`;
	const mapURL = `https://www.google.com/maps/place/${coordinates}`;

	const share = async () => {
		if (navigator.share) {
			try {
				await navigator.share({ url: mapURL });
			} catch (e: any) {
				if (e.toString().includes('AbortError')) {
					console.log('Ignored AbortError.');
				} else {
					window.displayCustomError(e.toString());
				}
			}
		} else if (navigator.clipboard) {
			await navigator.clipboard.writeText(mapURL);
			window.displaySuccess('Copied!');
		} else {
			console.log('HTTPS is required for this feature!');
		}
	};

	return (
		<div className="chat__location">
			<a href={mapURL} target="_blank" rel="noopener noreferrer" aria-label="Abrir ubicación en Maps" style={{display:'block',width:250,height:120,borderRadius:8,overflow:'hidden'}}>
				<svg viewBox="0 0 250 120" width="250" height="120" role="img" aria-label="Ilustración de ubicación, no es un mapa real">
					<rect width="250" height="120" fill="#eaf0e8"/>
					<path d="M0 80 Q70 35 120 80 T250 65" fill="none" stroke="#c8e3e8" strokeWidth="23"/>
					<path d="M-10 25L260 100M45-10L85 130M180-10L145 130" fill="none" stroke="#fff" strokeWidth="12"/>
					<path d="M-10 25L260 100M45-10L85 130M180-10L145 130" fill="none" stroke="#dce3dd" strokeWidth="1"/>
					<ellipse cx="125" cy="88" rx="13" ry="4" fill="#244e4330"/>
					<path d="M125 28a20 20 0 0 0-20 20c0 15 20 39 20 39s20-24 20-39a20 20 0 0 0-20-20z" fill="#237867"/>
					<circle cx="125" cy="48" r="7" fill="white"/>
				</svg>
			</a>

			{location?.name && (
				<div className="chat__message__location__name">{location.name}</div>
			)}
			{location?.address && (
				<div className="chat__message__location__address">
					{location.address}
				</div>
			)}
			{location?.url && (
				<a
					className="chat__message__location__url"
					href={location.url}
					target="_blank"
					rel="noopener noreferrer"
				>
					{location.url}
				</a>
			)}

			<div className="chat__message__location__actions">
				<Button
					className="chat__message__location__open"
					color="primary"
					size="small"
					disableElevation
					startIcon={<OpenInNewIcon />}
					href={mapURL}
					target="_blank"
					rel="noopener noreferrer"
				>
					Abrir en Maps
				</Button>

				<Button
					className="chat__message__location__share"
					color="primary"
					variant="outlined"
					size="small"
					disableElevation
					startIcon={<ShareIcon />}
					onClick={share}
				>
					{t('Share')}
				</Button>
			</div>
		</div>
	);
};

export default ChatMessageLocation;
